module.exports = __webpack_public_path__ + "static/media/Jam7.d1911888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam7.svg
// module id = 608
// module chunks = 0